import { ProviderEnum } from '@dynamic-labs/sdk-api';

const isEmailProviderEnabled = (providers) => providers.some(({ provider, enabledAt }) => [ProviderEnum.EmailOnly, ProviderEnum.MagicLink].includes(provider) &&
    Boolean(enabledAt));

export { isEmailProviderEnabled };
